import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenterVertical,
  FlexColCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { SubTitle } from './Favorites';
import { __ } from 'react-i18n/lib';
import { Required } from '../Auth/RegisterForm';
import { StyledInput } from '../Auth/WarehouseRegisterForm';
import { FormInput } from '../Form/FormInput';
import { FormSelect } from '../Form/FormSelect';
import { phonePrefixes } from '../Cart/utilities';

interface Props {
  email: string;
  phone: string;
  onChange: (e) => void;
  isB2B?: boolean;
  phonePrefix?: string;
  problems?: any;
}

function ContactInfoBlock({
  email,
  phone,
  phonePrefix,
  onChange,
  isB2B,
  problems,
}: Props) {
  const { phoneProblem } = {
    phoneProblem: problems?.person?.phone,
  };

  return (
    <Wrapper>
      <SubTitle>{`${__('Kontaktné údaje')}`}</SubTitle>
      <StyledFlexRowCenterVertical isB2B={isB2B}>
        {(!!email || !isB2B) && (
          <StyledInput marginRight={16}>
            <FormInput
              justText={isB2B}
              name={'email'}
              type="email"
              label={__('Email')}
              value={email}
              readOnly={true}
              marginRight={16}
            />
          </StyledInput>
        )}
        {/* {!!phone && (
          <StyledInput>
            <FormInput
              justText={isB2B}
              name={'phone'}
              type="text"
              required={true}
              label={__('Tel. číslo')}
              value={phone}
              onChange={onChange}
            />
          </StyledInput>
        )} */}

        {(!!phone || !isB2B) && (
          <AccountFormWrapper isB2B={false} noWrap={true} marginRight={32}>
            <FormSelect
              justText={isB2B}
              name="phonePrefix"
              label={__('Predvoľba')}
              value={phonePrefix}
              options={phonePrefixes.map(prefix => {
                return { value: prefix, name: prefix };
              })}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={onChange}
              // onBlur={handleBlur}
              marginBottom={16}
              maxWidth={38}
              maxWidthPx={96}
              marginRight={16}
              height={56}
            />
            <FormInput
              justText={isB2B}
              // inputRef={phoneRef}
              name={'phone'}
              type="text"
              required={true}
              label={__('Tel. číslo')}
              value={phone}
              // tslint:disable-next-line:jsx-no-lambda
              onChange={onChange}
              // onBlur={handleBlur}
              validMessage={phoneProblem}
              maxWidth={100}
              maxWidthPx={208}
              marginBottom={16}
              autoComplete="tel"
              validateAllowedChars={true}
            />
          </AccountFormWrapper>
        )}
      </StyledFlexRowCenterVertical>
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenterVertical)``;

const StyledFlexRowCenterVertical = styled(FlexColCenterVertical)<{
  isB2B?: boolean;
}>`
  justify-content: flex-start;
  flex-flow: ${({ isB2B }) => (isB2B ? 'column' : 'row')};

  ${({ theme }) => theme.mediab.m580`
    flex-flow: column;
  `}
`;

export const AccountFormWrapper = styled(FlexRowCenterVertical)`
  align-items: flex-start;
  margin-right: rem(48);
  max-width: rem(320);
  width: 100%;

  &:last-child {
    margin-right: 0;
  }

  ${({ theme }) => theme.mediab.m580`
    margin-right: 0;
    max-width: initial;
  `}
`;

export { ContactInfoBlock as DsiContactInfoBlock };
